/* QOWAA FIT — Page COLLECTION (popup exit-intent)
   Le reste de la page est statique / CSS-only (hover cards desktop, grille, compteur server-rendered).
   Popup : desktop, déclenché par sortie souris vers le haut, plafonné 1×/7 jours (localStorage).
   Le formulaire est un vrai {% form 'customer' %} : succès = rechargement Shopify avec ?customer_posted=true. */
(function () {
  'use strict';
  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  var KEY = 'qw-exit-popup-ts';
  var WEEK = 7 * 24 * 60 * 60 * 1000;

  function initPopup(root) {
    var overlay = $('[data-qw-popup-overlay]', root);
    var popup = $('[data-qw-popup]', root);
    if (!popup) return;
    var enabled = root.getAttribute('data-popup-enabled') === 'true';

    function open() { popup.classList.add('is-open'); if (overlay) overlay.classList.add('is-open'); }
    function close() { popup.classList.remove('is-open'); if (overlay) overlay.classList.remove('is-open'); }
    function markShown() { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} }
    function recentlyShown() {
      try { var t = parseInt(localStorage.getItem(KEY) || '0', 10); return t && (Date.now() - t) < WEEK; } catch (e) { return false; }
    }

    $all('[data-qw-popup-close]', root).forEach(function (b) { b.addEventListener('click', close); });
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && popup.classList.contains('is-open')) close(); });

    // État succès après soumission du formulaire newsletter (Shopify recharge avec ?customer_posted=true)
    var params = new URLSearchParams(window.location.search);
    if (params.get('customer_posted') === 'true') {
      var form = $('[data-qw-popup-form]', popup);
      var success = $('[data-qw-popup-success]', popup);
      if (form) form.hidden = true;
      if (success) success.hidden = false;
      open();
      return; // pas d'exit-intent quand on affiche déjà le succès
    }

    if (!enabled) return;

    // Exit-intent desktop : la souris quitte le haut du viewport
    var fine = window.matchMedia && window.matchMedia('(hover: hover) and (min-width: 1000px)').matches;
    if (!fine || recentlyShown()) return;
    var armed = true;
    function onMouseOut(e) {
      if (!armed) return;
      if (e.clientY <= 0 && !e.relatedTarget && !e.toElement) {
        armed = false;
        markShown();
        open();
        document.removeEventListener('mouseout', onMouseOut);
      }
    }
    // petit délai pour ne pas déclencher au tout premier mouvement
    setTimeout(function () { document.addEventListener('mouseout', onMouseOut); }, 3000);
  }

  function boot() { $all('[data-qw-collection]').forEach(initPopup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-qw-collection]'); if (r) initPopup(r); });
})();
